<template>
  <div style="margin: 0 auto;width: 100%;">
    <Header/>
    <AllMatch/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import AllMatch from './components/AllMatch'
import Footer from '../layout/Footer'
export default {
  components: {
    Header,
    AllMatch,
    Footer
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/ProgramMatch.vue